// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-item{

    /* min-width: 30px; */
    /* max-width: 7rem; */
    /* width: 3rem; */
}`, "",{"version":3,"sources":["webpack://./src/pages/SelectMultipleSDGsNum.css"],"names":[],"mappings":"AAAA;;IAEI,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;AACrB","sourcesContent":[".custom-item{\r\n\r\n    /* min-width: 30px; */\r\n    /* max-width: 7rem; */\r\n    /* width: 3rem; */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
